import React from "react";
import { useNavigate } from "react-router-dom";
import { Music, Laugh, UtensilsCrossed, Wine, Palette, Trophy, Users, Briefcase, Baby, Tag } from "lucide-react";

export const CATEGORY_META = {
  "Music": { icon: Music, color: "#2ec9c9" },
  "Comedy": { icon: Laugh, color: "#e0a419" },
  "Food & Drink": { icon: UtensilsCrossed, color: "#e05a5a" },
  "Nightlife": { icon: Wine, color: "#8b5cf6" },
  "Arts & Theatre": { icon: Palette, color: "#db2777" },
  "Sports": { icon: Trophy, color: "#0f9d76" },
  "Community": { icon: Users, color: "#2563eb" },
  "Business": { icon: Briefcase, color: "#64748b" },
  "Family": { icon: Baby, color: "#ea7a1c" },
  "Other": { icon: Tag, color: "#64748b" },
};

export const catMeta = (c) => CATEGORY_META[c] || { icon: Tag, color: "#64748b" };

export const CATEGORY_HERO = {
  "Music": "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  "Comedy": "https://images.pexels.com/photos/2101487/pexels-photo-2101487.jpeg?auto=compress&cs=tinysrgb&w=1600",
  "Food & Drink": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  "Nightlife": "https://images.unsplash.com/photo-1578736641330-3155e606cd40?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  "Arts & Theatre": "https://images.unsplash.com/photo-1514306191717-452ec28c7814?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  "Sports": "https://images.unsplash.com/photo-1563299796-b729d0af54a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export function CategoryTag({ category, size = 11, className = "", clickable = true }) {
  const navigate = useNavigate();
  if (!category) return null;
  const cm = catMeta(category);
  const Icon = cm.icon;
  const go = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`/events/category/${encodeURIComponent(category)}`);
  };
  return (
    <span data-testid={`category-tag-${category}`} onClick={clickable ? go : undefined}
      title={clickable ? `See all ${category} events` : undefined}
      className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full ${clickable ? "cursor-pointer hover:opacity-80 transition-opacity" : ""} ${className}`}
      style={{ background: cm.color + "22", color: cm.color }}>
      <Icon size={size} /> {category}
    </span>
  );
}
